import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '../base_services/http_base.service';
import { AccountSettingModel } from '@shared/model/account-setting-model';
import { ServiceResult } from '@shared/helper/service-result';


@Injectable({
  providedIn: 'root'
})

export class AccountSettingsService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'asset');
  }

  getSetting(): Observable<TServiceResult<AccountSettingModel>> {
    return this.http.get<TServiceResult<AccountSettingModel>>(`${this.apiUrl}/Get`)
  }

  changeSettings(setting: AccountSettingModel): Observable<ServiceResult> {
    return this.http.put<ServiceResult>(`${this.apiUrl}/Change`, setting);
  }

  resetSetting(): Observable<ServiceResult> {
    return this.http.delete<ServiceResult>(`${this.apiUrl}/ResetToDefault`);
  }
}
